import React from 'react';
import { jwtDecode } from 'jwt-decode';

import { getIsMsgOutgoing } from 'widget/actions';
import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useIsMutedDark } from 'widget/hooks';
import { useMsgContext } from '../../msg-context';
import * as Env from 'widget/env';

const Reactions = () => {
  const { accessToken, sendReaction } = useChatBodyContext();
  const { msg } = useMsgContext();

  const isMutedDark = useIsMutedDark();

  const handleClick = (reaction: Env.MessageReaction) => {
    if (!accessToken) return;

    const user = jwtDecode<Env.User>(accessToken);
    const isMine = reaction.user_id == user.user_id;

    sendReaction(msg.id, isMine ? '' : reaction.symbol);
  };

  const isOutgoing = getIsMsgOutgoing(accessToken, msg);
  const isReactions = !!msg.reactions && msg.reactions.length > 0;

  return (
    <>
      {isReactions && (
        <div
          className="whatcrm-widget-reactions"
          style={
            isOutgoing
              ? { background: isMutedDark ? '#7f7f7f' : '#dfdfdf' }
              : undefined
          }
        >
          {msg.reactions?.map((reaction, i) => (
            <button
              className="whatcrm-widget-reactions__item"
              key={i}
              onClick={() => handleClick(reaction)}
            >
              <span>{reaction.symbol}</span>
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default Reactions;
